import { ScaffoldSelection } from "../../interface";
import { isColInSelection } from "./isColInSelection";

/**
 * Toggles a column in the selectedCols list, adding it if absent or removing it if present.
 * Preserves all cell and row selections.
 *
 * @param selection - The current scaffold selection state.
 * @param colId - The column ID to toggle.
 * @returns A new selection state with the column toggled.
 */
export const toggleColInSelection = (
  selection: ScaffoldSelection,
  colId: string,
): ScaffoldSelection => {
  if (isColInSelection(selection, colId)) {
    return {
      ...selection,
      selectedCols: selection.selectedCols.filter((c) => c.firstCellId !== colId),
    };
  }

  return {
    ...selection,
    selectedCols: [...selection.selectedCols, { firstCellId: colId }],
  };
};
